import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Column = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  flex-basis: ${props => props.flexBasis};
  flex-grow: ${props => props.flexGrow};
  margin: 0;
  padding: 0 5px;
  width: ${props => props.width};
`

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-top: 16px;
  width: 100%;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: 0 -5px;
    padding: 0;
  }
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding || '12px 9px 16px'} !important;

    &:first-child {
      padding: ${props => props.padding || '12px 9px 16px 0'} !important;
    }

    &:last-child {
      border-right: 0;
      padding: ${props => props.padding || '12px 0 16px 9px'} !important;
    }
  }
`
